import Column from '@components/column'
import Search from '@commons/search'
import { useSelector } from 'react-redux'
import { FC, Fragment, useEffect, useState, useRef } from 'react'
import { Category, LabTest } from '@apis'
import Typography from '@components/typography'
import Image from '@components/image'
import Svg from '@components/svg'
import {
  StyleGrid,
  StyleGridItem,
  StyleCheckedIconWrapper,
  StyleSearchWrapper,
  StyleSearchItem,
  StyleWrapper,
} from './style'
import Empty from '@commons/empty'
import Circle from '@components/circle'
interface SearchLabTestsProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  selectedItems: any[]
  multiple?: boolean
  name: string
  selector: string
  type: string
}
const SearchLabTests: FC<SearchLabTestsProps> = ({
  selectedItems = [],
  multiple = false,
  setFieldValue,
  name,
  selector,
  type,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState<boolean>(false)
  const { data: categories } = useSelector((state: any) => state[selector])
  const { items: labTests } = useSelector((state: any) => state.labTests)
  const [loading, setLoading] = useState<boolean>(false)
  const fetchData = async () => {
    await Category.list({
      state: selector,
      params: {
        type: type,
      },
    })
  }

  const fetchItems = async (params) => {
    setLoading(true)
    await LabTest.list({
      params: {
        page: 1,
        limit: 20,
        ...params,
      },
    })
      .then(() => {
        setVisible(true)
      })
      .catch(() => {})
    setLoading(false)
  }

  const submitHandler = async (values) => {
    await fetchItems({
      search: values,
    })
  }

  const handleClickLabTest = async (event) => {
    const id = (event.target as HTMLElement)
      .closest('[data-id]')
      ?.getAttribute('data-id')

    if (!multiple && !!id) {
      if (!!labTests[id]) {
        setFieldValue(name, [labTests[id]])
      }
    }

    if (!!multiple && !!id) {
      if (!!labTests[id]) {
        const find = selectedItems?.find(
          (item: any) => item.id == labTests[id]?.id,
        )
        if (!!find?.id) {
          const filterItems = selectedItems?.filter(
            (item: any) => item?.id != labTests[id]?.id,
          )
          setFieldValue(name, filterItems)
        } else {
          setFieldValue(name, [...selectedItems, labTests[id]])
        }
      }
    }
  }
  const handleClickSymptom = async (event) => {
    const cross = (event.target as HTMLElement).closest('[data-cross-id]')
    if (!!cross) {
      const id = cross.getAttribute('data-cross-id')
      if (!!id) {
        await fetchItems({
          categoryId: id,
        })
      }
    }
  }
  const onClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setVisible(false)
    }
  }

  useEffect(() => {
    if (!categories?.length) {
      fetchData()
    }
    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])

  return (
    <Column rowGap={20}>
      <StyleWrapper ref={dropdownRef}>
        <Search
          onSubmit={submitHandler}
          placeholder="Search Lab Tests"
          loading={loading}
        />
        {!!visible && (
          <>
            {!!labTests?.length ? (
              <StyleSearchWrapper onClick={handleClickLabTest}>
                {labTests?.map((labTest: any, index) => {
                  const findIndex = selectedItems.findIndex(
                    (selectedItem) => selectedItem?.id == labTest?.id,
                  )
                  return (
                    <StyleSearchItem key={labTest?.id} data-id={index}>
                      <Circle size={25} bg={'inputBorder'}>
                        <Svg svg="search" size={14} color={'placeholder'} />
                      </Circle>
                      <Typography content={labTest?.name} size={14} tc="text" />
                      {findIndex >= 0 && (
                        <Svg svg={'circleTick'} color={'secondary'} size={14} />
                      )}
                    </StyleSearchItem>
                  )
                })}
              </StyleSearchWrapper>
            ) : (
              <Typography
                content="Not Lab Test Found"
                styleText="padding-top:10px;"
                size={14}
                tc="placeholder"
              />
            )}
          </>
        )}
      </StyleWrapper>

      <Typography content="Search by Category" size={14} tc="secondary" />
      {!categories?.length ? (
        <Empty />
      ) : (
        <StyleGrid onClick={handleClickSymptom}>
          {categories?.map((category: any, index: number) => {
            const findIndex = -1
            return (
              <Fragment key={category?.id}>
                <StyleGridItem data-id={index} data-cross-id={category?.id}>
                  <Image
                    width={50}
                    height={50}
                    styleImage={`border-radius:50%;`}
                    src={`${process.env.BUCKET_URL}/${category?.infos?.image}`}
                  />
                  <Typography
                    content={category?.name}
                    size={12}
                    styleText="text-align:center"
                  />
                  {findIndex >= 0 && (
                    <StyleCheckedIconWrapper>
                      <Svg svg="circleTick" color={'secondary'} />
                    </StyleCheckedIconWrapper>
                  )}
                </StyleGridItem>
              </Fragment>
            )
          })}
        </StyleGrid>
      )}
    </Column>
  )
}

export default SearchLabTests
